import PropTypes from 'prop-types'
import React from 'react'
import Loader from '../Loader'

import './Loading.scss'

export const Loading = ({ open, text }) => {
  return (
    <>
      {open && (
        <div className='e-loading'>
          {text && <div className='e-loading__text'>{text}</div>}
          <Loader
            lines={6}
            length={0}
            animation='spinner-line-fade-default'
            className='spinner'
            color='#16a7cd'
            fadeColor='transparent'
            corners={1}
            direction={1}
            left='50%'
            loaded={!open}
            loadedClassName='loadedContent'
            radius={10}
            rotate={90}
            shadow={false}
            speed={1.4}
            top='50%'
            width={10}
            scale={1.2}
            zIndex={200}
          />
        </div>
      )}
    </>
  )
}

Loading.defaultProps = {
  open: false
}

Loading.propTypes = {
  open: PropTypes.bool,
  text: PropTypes.string
}
